import {Component, OnInit, Inject, signal} from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule,
  AbstractControl
} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef, MatDialogModule} from '@angular/material/dialog';
import {TranslateModule} from '@ngx-translate/core';
import {CommonModule} from '@angular/common';
import {
  DialogCloseButtonComponent,
  InfoMessageComponent,
  PrimaryButtonComponent,
  SecondaryButtonComponent,
  TextareaFieldComponent,
  TextFieldComponent
} from '@q9elements/ui-kit/components';
import {Q9Validators} from '@q9elements/ui-kit/validators';
import {finalize} from 'rxjs';
import {AuthService} from '../../../core/auth/auth.service';
import {OnSubmitErrorStateMatcher} from '../../../core/helpers/on-submit-error-state-matcher';
import {AuthorisationService} from '../../../core/services/authorisation.service';
import {getAuthorisationErrors} from '../../shared/utils/get-authorisation-errors';

@Component({
  selector: 'app-reject-task-dialog',
  templateUrl: './reject-task-dialog.component.html',
  styleUrls: ['./reject-task-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    TranslateModule,
    DialogCloseButtonComponent,
    PrimaryButtonComponent,
    SecondaryButtonComponent,
    TextareaFieldComponent,
    TextFieldComponent,
    InfoMessageComponent
  ]
})
export class RejectTaskDialogComponent implements OnInit {
  public form: UntypedFormGroup;
  public matcher = new OnSubmitErrorStateMatcher();
  public error: string;
  public havePassword = false;
  public isLoading = signal(false);
  public MIN_PASSWORD_CHARACTERS = 6;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<RejectTaskDialogComponent>,
    private authService: AuthService,
    private authorisationService: AuthorisationService
  ) {}

  ngOnInit() {
    this.initAuthorisationFormReject();
  }

  public get passwordControl() {
    return this.form.get('password') as AbstractControl;
  }

  private initAuthorisationFormReject() {
    this.form = new UntypedFormGroup({
      reason: new UntypedFormControl('', [
        Q9Validators.required(),
        Q9Validators.minLength(10),
        Q9Validators.maxLength(5000)
      ])
    });
    const user = this.authService.getUserDataSync();

    this.havePassword = user.havePassword;

    if (this.havePassword) {
      this.form.addControl(
        'password',
        new UntypedFormControl('', [
          Q9Validators.required(),
          Q9Validators.minLength(this.MIN_PASSWORD_CHARACTERS)
        ])
      );
    }
  }

  public onSubmit() {
    if (this.form.valid && !this.isLoading()) {
      const password = this.passwordControl?.value ?? '';
      const reason = this.form.get('reason')?.value;
      const diagramId = this.data;

      this.isLoading.set(true);

      this.authorisationService
        .rejectTask({diagramId, comment: reason, password})
        .pipe(finalize(() => this.isLoading.set(false)))
        .subscribe({
          next: res => this.dialogRef.close(res),
          error: ({error}) => (this.error = getAuthorisationErrors(error, this.passwordControl))
        });
    }
  }
}
